module.exports=function(scope){ return `{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev"
    },
    "data": "Congratulations, your connection to the biometrics webservice is successful."
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/test-connection.json.tpl